/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import * as fromHelpers from './helpers.js'
import AppsLauncherProperties from 'DesignSystem/AppsLauncherProperties/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/DesignSystem/ImageCard/Content/Content/LauncherProps/Content"
  
}) {
  let setFlowTo = fromFlow.useSetFlowTo(viewPath)
let patientImageLauncherValueData = fromData.useDataValue({ viewPath,
context: 'patient_image',
path: 'launcher',
})
let patientImageIdValueData = fromData.useDataValue({ viewPath,
context: 'patient_image',
path: '_id',
})
let onLauncherResolved = fromHelpers.useOnLauncherResolved({
  children,
  viewPath
  
})
  return (<React.Fragment
>
<AppsLauncherProperties
  viewPath={`${viewPath}/AppsLauncherProperties`}
 data="patient_image.launcher"
 launcher={patientImageLauncherValueData}
 data="patient_image._id"
 resourceId={patientImageIdValueData}
 onClose={() => setFlowTo(fromFlow.normalizePath(viewPath, '../No'))}
 onLauncherResolved={onLauncherResolved}
/>
{children}
</React.Fragment>)
}